import Hyperlink from "@components/hyperlink/index";
import { debounceTime, filter, fromEvent, map, tap } from "rxjs";

const querySelector = '[data-hyperlink-item]';
const getHyperLinkElement = (element) => element.closest(querySelector);

/**
 * Observable that emits hyperlink elements clicked within the specified root element.
 * 
 * This observable listens for 'click' events on the root element, extracts the hyperlink element
 * from the event target using `getHyperLinkElement`, filters out non-hyperlink clicks, and
 * debounces the emission by 400 milliseconds to prevent rapid consecutive clicks.
 *
 * @constant {Observable<HTMLElement>}
 */
const onHyperlinkClick$ = fromEvent(document, 'click', { capture: true })
  .pipe(
    filter((event) => !!getHyperLinkElement(event.target)),
    tap((event) => event.preventDefault()),
    map((event) => getHyperLinkElement(event.target)),
    filter(Boolean),
    debounceTime(400),
  );

onHyperlinkClick$.subscribe((element) => {
  const hyperlink = new Hyperlink(element);
  hyperlink.handler();
});

export default onHyperlinkClick$;
